exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-warning.text-white h4.d-inline a {\n    text-decoration: underline;\n    color: #0a3272;\n}\n.bg-warning.text-white h4.d-inline a:hover{\n    text-decoration: none;\n    color:white;\n}\n\n\n\n", ""]);

// exports
